import React from "react";
import IMG from "../images/IMG.jpg";
import './About.css'; // Ensure you have a CSS file for styling

const About = () => {
  return (
    <div className="about-container">
      <h1>About Me</h1>
      <div className="content">
        <p>
          Hi, I am a software developer with a passion for building innovative and user-friendly software based on user needs.
          I have experience in website development, both front-end and back-end, with skills including HTML, CSS, JavaScript, and React.js for the front end. For the backend, I use PHP (Laravel) and MySQL for database management. I use Git and GitHub for version control to store source codes.
        </p>
        <p>
          I graduated from the Institute of Accountancy Arusha, Arusha campus in Arusha region, with a degree in Information Technology. I enjoy working on exciting projects that challenge me and allow me to grow as a developer.
        </p>
        <p>
          When I'm not coding, you can find me watching movies, walking around, reading, or playing video games.
        </p>
        <p>
          Feel free to check out my projects and get in touch if you'd like to collaborate!
        </p>
      </div>
      <img src={IMG} alt="mypic" />
    </div>
  );
}

export default About;
